import { useQuery } from "react-query";
import api from "../services/api";
import { Organization } from "../types";

export const useTaskCategories = (organizationId: Organization["uid"]) =>
  useQuery([`task-categories-${organizationId}`, organizationId], () =>
    api.fetchTaskCategories(organizationId)
  );
